var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"deliverable-type-title"},[_c('span',{staticClass:"field-label"},[_vm._v("TYPE: ")]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.deliverableTypeTitle(_vm.deliverable.deliverable_template_id)))])])}
var staticRenderFns = []

export { render, staticRenderFns }